import { render, staticRenderFns } from "./snakbar.vue?vue&type=template&id=0b6d5b34&scoped=true&"
import script from "./snakbar.vue?vue&type=script&lang=js&"
export * from "./snakbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b6d5b34",
  null
  
)

export default component.exports